import Vue from 'vue';
import { useStore } from '@/stores';
export default Vue.extend({
    name: 'OrganizationSwitcher',
    data() {
        return {
            menuOpen: false,
            showModal: false,
            newTeamName: '',
            loading: false,
            error: null,
        };
    },
    computed: {
        store() {
            return useStore();
        },
        currentOrg() {
            return this.store.organization.currentOrganization;
        },
        currentOrgName() {
            return this.currentOrg?.name || 'Loading...';
        },
        orgIcon() {
            if (!this.currentOrg)
                return '⏳';
            return this.currentOrg.is_personal ? '👤' : '👥';
        },
        personalOrg() {
            // Directly filter from organizations array for better reactivity
            const all = this.store.organization.organizations;
            console.log('[OrganizationSwitcher] Looking for personal org in:', all.map(o => ({ id: o.id, name: o.name, is_personal: o.is_personal })));
            const org = all.find(o => o.is_personal === true) || null;
            console.log('[OrganizationSwitcher] personalOrg computed:', org, 'from', all.length, 'orgs');
            return org;
        },
        teamOrgs() {
            // Directly filter from organizations array for better reactivity
            const all = this.store.organization.organizations;
            console.log('[OrganizationSwitcher] Looking for team orgs in:', all.map(o => ({ id: o.id, name: o.name, is_personal: o.is_personal })));
            const orgs = all.filter(o => o.is_personal === false);
            console.log('[OrganizationSwitcher] teamOrgs computed:', orgs, 'from', all.length, 'orgs');
            return orgs;
        },
        allOrganizations() {
            const all = this.store.organization.organizations;
            console.log('[OrganizationSwitcher] allOrganizations:', all);
            return all;
        },
        isAdmin() {
            return this.store.organization.isAdmin;
        },
    },
    async mounted() {
        console.log('[OrganizationSwitcher] Component mounted');
        // Load organizations on mount
        await this.store.organization.loadOrganizations();
        console.log('[OrganizationSwitcher] After loadOrganizations - count:', this.store.organization.organizations.length);
    },
    watch: {
        'store.organization.organizations': {
            handler(newOrgs) {
                console.log('[OrganizationSwitcher] Organizations changed:', newOrgs);
                // Force re-computation of computed properties
                this.$forceUpdate();
            },
            deep: true
        }
    },
    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
            console.log('[OrganizationSwitcher] toggleMenu - menuOpen:', this.menuOpen);
            if (this.menuOpen) {
                console.log('[OrganizationSwitcher] Menu opened - personalOrg:', this.personalOrg);
                console.log('[OrganizationSwitcher] Menu opened - teamOrgs:', this.teamOrgs);
                console.log('[OrganizationSwitcher] Menu opened - all orgs:', this.allOrganizations);
            }
        },
        closeMenu() {
            this.menuOpen = false;
        },
        isCurrentOrg(orgId) {
            return this.currentOrg?.id === orgId;
        },
        async selectOrg(orgId) {
            if (this.isCurrentOrg(orgId)) {
                this.closeMenu();
                return;
            }
            try {
                await this.store.organization.selectOrganization(orgId);
                this.closeMenu();
                // Reload session list for new org context
                this.$emit('org-changed', orgId);
            }
            catch (error) {
                console.error('[OrganizationSwitcher] Failed to switch organization:', error);
            }
        },
        showCreateTeam() {
            console.log('[OrganizationSwitcher] ========== CREATE TEAM CLICKED ==========');
            console.log('[OrganizationSwitcher] Current showModal:', this.showModal);
            console.log('[OrganizationSwitcher] Setting showModal to true...');
            this.showModal = true;
            this.newTeamName = '';
            this.error = null;
            this.closeMenu();
            console.log('[OrganizationSwitcher] After setting, showModal:', this.showModal);
            console.log('[OrganizationSwitcher] ========================================');
        },
        closeModal() {
            this.showModal = false;
            this.newTeamName = '';
            this.error = null;
        },
        async createTeam() {
            if (!this.newTeamName.trim())
                return;
            this.loading = true;
            this.error = null;
            try {
                await this.store.organization.createOrganization({
                    name: this.newTeamName.trim()
                    // is_personal will be false by default (team org)
                });
                this.closeModal();
                this.$emit('org-created');
            }
            catch (error) {
                this.error = error.message;
                console.error('[OrganizationSwitcher] Failed to create team:', error);
            }
            finally {
                this.loading = false;
            }
        },
        navigateToManagement() {
            this.closeMenu();
            this.$router.push('/organizations/manage');
        },
    },
});
